<template>
  <div v-if="width === 'fixed' && isWide" class="flex justify-center">
    <div
      class="max-w-full grow lg:max-w-[1184px] lg:basis-full lg:px-0 xl:max-w-[1618px]"
    >
      <slot />
    </div>
  </div>

  <RevContainer v-else-if="width === 'fixed' && !isWide">
    <div class="md:min-w-full md:max-w-[752px] lg:max-w-[1184px]">
      <slot />
    </div>
  </RevContainer>

  <div v-else-if="width === 'full-width'">
    <slot />
  </div>

  <div
    v-else-if="width === 'adaptive' && isWide"
    class="m-auto md:px-24 lg:max-w-[1120px] lg:px-0 xl:max-w-[1618px]"
  >
    <slot />
  </div>

  <div
    v-else-if="width === 'adaptive' && !isWide"
    class="m-auto md:px-24 lg:max-w-[1120px] lg:px-0"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { RevContainer } from '@ds/components/Container'

withDefaults(
  defineProps<{
    width?: 'adaptive' | 'full-width' | 'fixed'
    // For the moment added for this request: https://backmarket.atlassian.net/browse/SR-5740
    // changing the width for the whole CMS scope required syncing with the DS etc...
    // this is a temporary test until we get the results for the "plpWideContainer" experiment.
    isWide?: boolean
  }>(),
  {
    width: 'fixed',
    isWide: false,
  },
)
</script>
